<template>
  <div>
    <div class="mx-2 pt-2 py-2">
      <h1 class="flex justify-center text-2xl 100vh mb-5 pt-10">Create User</h1>
      <form class="max-w-md mx-auto" @submit.prevent="submit">
        <div class="mb-5">
          <label
            for="text"
            class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          >
            User Name</label
          >
          <input
            type="text"
            v-model="username"
            id="username"
            class="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
            placeholder="User"
            required
          />
        </div>
        <div class="mb-5">
          <label
            for="text"
            class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          >
            Display Name</label
          >
          <input
            type="text"
            v-model="display_name"
            id="displayname"
            class="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
            placeholder="Display Name"
            required
          />
        </div>
        <div class="mb-5">
          <label
            for="countries"
            class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
            >Select Working Hospital</label
          >
          <select
            id="hospitals"
            ref="staffHospital"
            multiple
            v-model="hospital_id"
            style="height: 40px"
            class="bg-white rounded-lg border mt-5 md:pt-0 mr-3 border-gray-300 text-gray-900 text-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-bg-save dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <option value=""></option>
            <option
              v-for="hospital in selectHospitals"
              :key="hospital.id"
              :value="hospital.id"
            >
              {{ hospital.name }}
            </option>
          </select>
        </div>
        <div class="mb-5" v-if="hascanassignroletouser">
          <label
            for="countries"
            class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
            >Select Role</label
          >
          <select
            id="countries"
            v-model="role_id"
            class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <option selected value="0">Choose a Roles</option>
            <option v-for="rol in role" :key="rol.id" :value="rol.id">
              {{ rol.name }}
            </option>
          </select>
        </div>
        <!-- <div class="mb-5" v-if="hasCanSignSiteToUser">
                    <label for="countries" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"> 
                        Working Sites</label>
                    <select id="countries" v-model="working_site_id"
                        class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                        <option selected>Choose a sites</option>
                        <option v-for="site in selectSites" :key="site.id" :value="site.id">{{ site.name }}
                        </option>
                    </select>
                </div> -->
        <div class="mb-5" v-if="hasCanSignSiteToUser">
          <!-- v-model="counteryid" -->
          <div class="flex justify-between">
            <span>
              <label
                for="countries"
                class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Other Hospitals</label
              ></span
            >
            <div class="flex items-center mb-4">
              <input
                id="default-checkbox"
                v-model="allHospital"
                type="checkbox"
                value=""
                class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
              />
              <label
                for="default-checkbox"
                class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              >
                {{ allHospital ? "Unselect all " : "Select all " }}
              </label>
            </div>
          </div>
          <select
            ref="hospitalsSelect2s"
            multiple
            id="hospitalsSelect2"
            style="height: 40px; background: white"
            class="js-example-disabled-results bg-white rounded-lg border mt-5 md:pt-0 mr-3 border-gray-300 text-gray-900 text-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-bg-save dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <option value=""></option>
            <option v-for="site in selectSites" :key="site.id" :value="site.id">
              {{ site.name }}
            </option>
          </select>
        </div>
        <div class="mb-5">
          <label
            for="email"
            class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          >
            Email</label
          >
          <input
            type="email"
            id="email"
            v-model="email"
            class="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
            placeholder="name@flowbite.com"
          />
        </div>
        <div class="mb-5">
          <label
            for="password"
            class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
            >Your password</label
          >
          <input
            type="password"
            v-model="password"
            id="password"
            placeholder="****"
            class="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
            required
          />
        </div>

        <div class="flex items-center justify-center">
          <router-link
            to="user"
            class="text-white mb-5 bg-button-blue focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          >
            Back</router-link
          >
          <button
            type="submit"
            class="text-white mb-5 ml-5 bg-bg-save focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          >
            Create New User
          </button>
        </div>
      </form>
    </div>
  </div>
</template>


<script setup>
import $ from "jquery";
import "select2";
import { ref, watch, computed, onMounted, watchEffect, onUnmounted } from "vue";
import axiosInstce from "@/plugins/axios";
const selectHospitals = ref([]);
const selectSites = ref([]);
const username = ref();
const email = ref();
const display_name = ref();
const password = ref();
const working_site_id = ref();
const role_id = ref(0);
const hospital_id = ref();
const change_hospital = ref([]);
// const hospital_ids = ref([])
const role = ref();
const allHospital = ref(false);
import Swal from "sweetalert2";
import { useRouter } from "vue-router"; // Import the useRouter function from vue-router
const router = useRouter();
const roles = () => {
  axiosInstce
    .get(`/roles`)
    .then((response) => {
      role.value = response.data.data.roles;
    })
    .catch((error) => {
      console.error("Error fetching sites:", error);
    });
};
const getHospitals = () => {
  const hospitalId = 100000000;
  axiosInstce
    .get(`/all-hospitals`)
    .then((response) => {
      // console.log('Hospitals API response:', response.data.data);
      const hospital = response.data.data;
      const districtNames = hospital.map((hospitals) => hospitals);
      selectHospitals.value = districtNames;
      selectSites.value = districtNames;
    })
    .catch((error) => {
      console.error("Error fetching hospitals:", error);
    });
};
const submit = async () => {
  try {
    const selectedHospitals = $("#hospitals").val();
    const selectedSiteHospital = $("#hospitalsSelect2").val();

    if (selectedSiteHospital && selectedSiteHospital.includes("all")) {
      if (selectedSiteHospital.length > 1) {
        Swal.fire({
          title: "Warning",
          text: "Please select hospitals individually or select 'All'.",
          icon: "warning",
          confirmButtonText: "OK",
        });
        return;
      }
    } else if (selectedHospitals && selectedHospitals.length > 1) {
      Swal.fire({
        title: "Warning",
        text: "Please select only one working hospital.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return; // Stop further execution
    } else if (role_id.value === 0) {
      Swal.fire({
        title: "Warning",
        text: "Please select a role.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }
    const response = await axiosInstce.post("/users", {
      username: username.value,
      display_name: display_name.value,
      email: email.value,
      role_id: role_id.value,
      hospital_id: selectedHospitals[0],
      working_site_id: working_site_id.value,
      other_site_ids: $("#hospitalsSelect2").val(),
      password: password.value,
      all_hospitals_selected: allHospital.value ? 1 : 0,
    });
    Swal.fire({
      toast: true,
      title: "User created successfully.",
      icon: "success",
      position: "top-end",
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
    });
    router.push({ name: "user" });
  } catch (error) {
    console.error("Error fetching district info:", error);
    Swal.fire({
      toast: true,
      title: error.response.data.message,
      icon: "error",
      position: "top-end",
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
    });
  }
  // form.value = '';
  // router.push({ name: 'shift' });
};
import { useAuthService } from "@/store/Auth"; //  auth.js file
const authStore = useAuthService();
const permissions = ref([]);
onMounted(() => {
  const authData = authStore.authData;
  permissions.value = authStore.authData.permissions;
});
const hasCanSignSiteToUser = computed(() =>
  permissions.value.some(
    (permission) => permission.name === "can assign site to user"
  )
);
const hascanassignroletouser = computed(() =>
  permissions.value.some(
    (permission) => permission.name === "can assign role to user"
  )
);
const hospitalsSelect2s = ref(null);

onMounted(async () => {
  getHospitals();
  roles();
});
// Watcher for allHospital variable
watch(allHospital, (newValue, oldvalue) => {
  if (newValue === true) {
    $("#hospitalsSelect2")
      .val(selectSites.value.map((site) => site.id))
      .trigger("change");
    // hospital_ids.value = []
  } else if (allHospital.value) {
    $("#hospitalsSelect2").val([]).trigger("change");
  } else {
    if ($("#hospitalsSelect2").val().length === selectSites.value.length) {
      $("#hospitalsSelect2").val([]).trigger("change");
    }
  }
});
onMounted(() => {
  watchEffect(() => {
    if (hospitalsSelect2s.value) {
      $(hospitalsSelect2s.value).select2();
      $(hospitalsSelect2s.value).on("change", () => {
        change_hospital.value = $("#hospitalsSelect2").val();
        // Check if the length of selected hospitals is equal to the length of all hospitals
        if (change_hospital.value.length !== selectSites.value.length) {
          allHospital.value = false;
        }
        if (change_hospital.value.length === selectSites.value.length) {
          allHospital.value = true;
        }
      });
    }
  });
});

// ... other methods
$(document).ready(function () {
  // Initialize Select2 for Select 1
  $("#hospitalsSelect1").select2({
    placeholder: "Hospitals",
    allowClear: true,
  });
  $("#hospitalsSelect2").select2({
    placeholder: "Other Hospitals",
    allowClear: true,
  });
  // Initialize Select2 for Select 1
  $("#hospitals").select2({
    placeholder: "Working Hospital",
    allowClear: true,
  });
});

onMounted(async () => {
  await authStore.handlepermission();
});

onUnmounted(async () => {
  await authStore.handlepermission();
});
</script>

<style></style>